import {
  Link,
  MessageBar,
  MessageBarButton,
  MessageBarType,
} from "@fluentui/react";

interface IMensajeCorrecto {
  mensaje: string;
  onDismiss: () => void;
}

export const MensajeBarCorrecto = (props: IMensajeCorrecto) => {
  return (
    <div>
      <MessageBar
        //onDismiss={props.onDismiss}
        messageBarType={MessageBarType.success}
        isMultiline={true}
      >
        {props.mensaje}
      </MessageBar>
    </div>
  );
};
